module.exports = __webpack_public_path__ + "img/1.8ade0496.png";